import { AditionConfig } from './interfaces';

export const CONFIG_ENVIRONMENT = 'REPLACE:CONFIG_ENVIRONMENT';

// Default Permission Client config.
export const CONFIG_STORAGE_KEY = 'UI_CMP_PERMISSION_DATA';
export const CONFIG_PERMISSION_CORE_PATH = 'REPLACE:CONFIG_PERMISSION_CORE_PATH';
export const CONFIG_VERSION = 'REPLACE:CONFIG_APP_VERSION';
export const CONFIG_LAYER_DEFAULT_CLASSNAME = 'permission-layer-default';
export const CONFIG_CORE_IFRAME_CLASSNAME = 'permission-core-iframe';
export const CONFIG_SENTRY_DSN_DEFAULT = 'REPLACE:CONFIG_SENTRY_DSN_DEFAULT';
export const CONFIG_SENTRY_DSN_IOS = 'REPLACE:CONFIG_SENTRY_DSN_IOS';
export const CONFIG_SENTRY_DSN_ANDROID = 'REPLACE:CONFIG_SENTRY_DSN_ANDROID';

// Cookies
export const CONFIG_IDENTITY_COOKIE_IDENTIFIER = 'tp_id';
export const CONFIG_IAB_TCF_COOKIE_IDENTIFIER = 'euconsent-v2';
export const LOCAL_STORAGE_IDENTIFIER_DEBUG = 'PPP_DEBUG';

let trackingEnabled: boolean;
try {
  trackingEnabled = JSON.parse('REPLACE:TRACKING_ENABLED');
} catch {
  // only for unit tests where REPLACE:* strings aren't replaced
  trackingEnabled = true;
}
export const CONFIG_TRACKING_ENABLED = trackingEnabled;
export const CONFIG_TRACKING_SAMPLE_RATE = 0.01;

export const CONFIG_CORE_SOFT_NAME = 'pppcore';
export const CONFIG_CLIENT_SOFT_NAME = 'pppclient';
export const CONFIG_LAYER_SOFT_NAME = 'ppplayer';
export const CONFIG_CORE_TOUCHPOINT_VISUALIZATION = 'b4576802-bd8d-4a45-bc38-00012aa445cd';
export const CONFIG_CORE_PERM_TGP = 'TRACKING_AND_PROFILING';
export const CONFIG_CORE_PERM_CONSENT_STRINGS = 'CONSENT_STRINGS';

export const CONFIG_PERMISSION_CORE_BASE_URL: { [key: string]: string } = {
  'webde': 'https://dl.web.de/permission',
  'gmx': 'https://dl.gmx.net/permission',
  'gmxnet': 'https://dl.gmx.net/permission',
  'gmxat': 'https://dl.gmx.at/permission',
  'gmxch': 'https://dl.gmx.ch/permission',
  'gmxes' : 'https://dl.gmx.es/permission',
  'gmxfr' : 'https://dl.gmx.fr/permission',
  'gmxcom' : 'https://dl.gmx.com/permission',
  'gmxcouk' : 'https://dl.gmx.co.uk/permission',
  'mailcom' : 'https://dl.mail.com/permission',
  '1und1' : 'https://dl.1und1.de/permission',
  '1und1de' : 'https://dl.1und1.de/permission',
  'uim' : 'https://dl.gmx.com/permission'
};

// ADITION Config
export const CONFIG_ADITION: AditionConfig = {
    PRF_PARAM_PREFIX: {
        CONSENT: 'c',
        CONSENT_PARAMETER: 'cp'
    },
    DEFAULT: {
        TAGID: 'permission',
        LAYOUTCLASS: 'b',
        REQUEST_TYPE: 'x',
        NETWORK: '42',
    },
    ENDPOINT: {
        'webde': 'https://plus.web.de',
        'gmx': 'https://plus.gmx.net',
        'gmxnet': 'https://plus.gmx.net',
        'gmxat': 'https://plus.gmx.at',
        'gmxch': 'https://plus.gmx.ch',
        'gmxes': 'https://plus.gmx.es',
        'gmxfr': 'https://plus.gmx.fr',
        'gmxcom': 'https://plus.gmx.com',
        'mailcom': 'https://dl.mail.com/permission/ot_layer/index.html',
        'gmxcouk': 'https://plus.gmx.co.uk',
        '1und1': 'https://plus.1und1.de',
        '1und1de': 'https://plus.1und1.de',
        'uim': 'https://plus.gmx.com'
    }
};

// PPS/CATS Config
let corePpsUrl: { [key: string]: string };
try {
  corePpsUrl = JSON.parse('REPLACE:CONFIG_CORE_PPS_URL');
} catch (ex) {
  // only for unit tests where REPLACE:* strings aren't replaced
  corePpsUrl = {};
}
export const CONFIG_CORE_PPS_URL = corePpsUrl;

export const CONFIG_CORE_PPS_ENDPOINT_UAS = 'REPLACE:CONFIG_CORE_PPS_ENDPOINT_UAS';
export const CONFIG_CORE_PPS_ENDPOINT_TPID = 'REPLACE:CONFIG_CORE_PPS_ENDPOINT_TPID';
export const CONFIG_CORE_PPS_ENDPOINT_GUID = 'REPLACE:CONFIG_CORE_PPS_ENDPOINT_GUID';
